@import '~@sydle/ui-design-system/styles/scss/typography/index';

:host {
  display: block;
}

sy-text {
  color: var(--sy-surface, #ffff);
}

.sublist {
  margin-left: 8px;
  margin-top: 9px;
}

.subcategory {
  margin-top: 12.8px;
}

ul {
  padding: 0;
  color: #686e78;
  text-align: left;
  list-style-type: none;

  li {
    padding-top: var(--sy-spacer-3, 8px);
    padding-bottom: var(--sy-spacer-3, 8px);

    a {
      text-decoration: none;

      sy-text {
        color: #686e78;

        &:hover {
          color: #ffff;
        }
      }

      &:hover {
        text-decoration: none;
      }
    }
  }
}
